import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ConfirmationEntity } from '../../models/confirmation/ConfirmationEntity';

interface ConfirmationState {
  readonly pending: ConfirmationEntity[];
}

const initialState: ConfirmationState = {
  pending: [],
};

const confirmationSlice = createSlice({
  name: 'confirmation',
  initialState,
  reducers: {
    show(state, { payload }: PayloadAction<ConfirmationEntity>) {
      state.pending.push(payload);
    },
    close(state) {
      state.pending.splice(0, 1);
    },
    approve(state) {
      state.pending.splice(0, 1);
    },
    approveCatalogs(state, _action: PayloadAction<{ answer?: string }>) {
      state.pending.splice(0, 1);
    },
  },
});

export const confirmationReducer = confirmationSlice.reducer;

export default confirmationSlice.actions;
